import type { TeamId, Totals } from '../game/match';
import type { Teams } from '../shared/schemas';

interface Props {
  teams: Teams;
  t: Totals;
  leader: TeamId | null;
  deals: number;
  canEdit: boolean;
  onKeepPlaying: (hands: number) => void;
  onFinish: () => void;
}

/** Shown when every scheduled hand is dealt: keep playing another round, or finish. */
export function RoundComplete({ teams, t, leader, deals, canEdit, onKeepPlaying, onFinish }: Props) {
  const gap = Math.abs(t.guaaA - t.guaaB);
  return (
    <section className="card overflow-hidden" aria-labelledby="round-h">
      <div className="p-4">
        <p className="eyebrow text-[10px] text-gold">Round complete · {deals} deals</p>
        <h2 id="round-h" className="font-display text-2xl leading-tight font-extrabold">
          {leader ? (
            <>
              <span style={{ color: teams[leader].color }}>{teams[leader].name}</span> lead by {gap} Guaa
            </>
          ) : (
            <>Level at {t.guaaA} Guaa each</>
          )}
        </h2>
        <p className="mt-1 text-sm text-ink-soft">
          {canEdit ? 'Play another round, or finish the match here.' : 'Waiting for the scorekeeper to continue or finish.'}
        </p>
      </div>
      {canEdit && (
        <div className="space-y-2 border-t border-ink/10 bg-ink/[0.03] p-4">
          <div className="grid grid-cols-2 gap-2">
            {[2, 3].map((hands) => (
              <button key={hands} type="button" className="btn btn-ink flex-col gap-0 py-3" onClick={() => onKeepPlaying(hands)}>
                <span className="text-base">+{hands} hands each</span>
                <span className="text-xs font-normal text-cream/75">{hands * 4} more deals</span>
              </button>
            ))}
          </div>
          <button type="button" className="btn btn-primary w-full" onClick={onFinish}>
            🏁 Finish match
          </button>
        </div>
      )}
    </section>
  );
}
